// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'

import {
  FaArrowDown,
  FaArrowUp,
} from 'components/FontAwesome'

const SortIcon = ({ field, tableSort }) => {
  // tableSort === null is the default sorting state.
  // if we're not sorting by this column, don't render anything.
  if (tableSort === null || tableSort?.col !== field) {
    return null
  }

  // otherwise, choose if it should be an up or down arrow.
  return (
    tableSort.asc
      ? <FaArrowUp className={'margin-left-half'} />
      : <FaArrowDown className={'margin-left-half'} />
  )
}

SortIcon.propTypes = {
  field: string.isRequired,
  tableSort: object,
}

export default SortIcon
